import script from "./VensoDeliveryImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoDeliveryImage.vue?vue&type=script&setup=true&lang=ts"

import "./VensoDeliveryImage.vue?vue&type=style&index=0&id=1ef568c6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef568c6"]])

export default __exports__